import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { AppointmentRequest } from '../../domain/models/appointment-request.model';
import { AppointmentRequestKind } from '../../domain/models/appointment-request-kind.model';
import { AppointmentRequestStatus } from '../../domain/models/appointment-request-status.model';
import { IAppointmentRequestsRepository } from '../../domain/repositories/appointment-requests.repository';
import { AppointmentRequestsRemoteDatasource } from '../datasources/remote/appointment-requests.remote-datasource';
import { AppointmentRequestMapper } from '../mappers/appointment-request.mapper';

@Injectable()
export class AppointmentRequestsRepositoryImpl implements IAppointmentRequestsRepository {
  private readonly datasource = inject(AppointmentRequestsRemoteDatasource);
  private readonly mapper = inject(AppointmentRequestMapper);

  public list(status: AppointmentRequestStatus, kind?: AppointmentRequestKind): Observable<readonly AppointmentRequest[]> {
    return this.datasource.list(status, kind).pipe(
      map((dto) => dto.Items.map((item) => this.mapper.toAppointmentRequest(item))),
    );
  }
}
